var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 1.3c-.3-.6-.9-.9-1.5-.8-.3 0-.6.2-.8.4-1.7 1.7-3.2 3.3-4.6 4.9-1.2 1.3-2.4 2.5-3.6 3.8L2.9 7c-.4-.4-1-.5-1.5-.3-.4.2-.8.6-.9 1.1-.1.5.1 1 .5 1.4l4.1 3.5c.2.2.6.3.9.3.4 0 .7-.1 1-.4 1.7-1.7 3.1-3.3 4.6-4.8C13 6.2 14.4 4.7 16.1 3c.4-.4.5-1.1.3-1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d007b47289130a586a1a1c09e87c46bc.svg";
export { ForwardRef as ReactComponent };